module.exports = __webpack_public_path__ + "static/media/huawei_recent_2.ebf23780.png";